module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/logo_tag-3679d0f59828a20dd7615769fe52fcba.png";